import { useIntl } from 'react-intl';
import { Header, NavBar, headerNavigationRegistration } from '@marketplace/common';
import { Logo, Icon, Button } from '@marketplace/ui-elements';
import { Footer as FooterCommon } from '../../pages/layouts/landing-layout/footer/footer';
import classes from './page-not-found.module.scss'

export const PageNotFound = () => {
    const { formatMessage } = useIntl();
    const readmeredirect = 'https://greenwayhealth-group.readme.io/developer-platform';

    const handleOnClick = () => {
        window.location.replace(readmeredirect);
    }

    return (
        <div className={classes.pagenotfound}>
            <div>
                <Header
                    logo={<Logo subLogo={formatMessage({ id: 'developer_landing_header_sub_logo' })} />}
                    leftSection={<NavBar options={headerNavigationRegistration} />}
                />
            </div>
            <div className={classes.containerbody}>
                <div className={classes.containermessage}>
                    <div>
                        <span className={classes.sectionheader}>Error 404 - Page Not Found</span>
                    </div>
                    <hr></hr>
                    <div className={classes.containerinfo}>
                        <div className={classes.containericon}>
                            <Icon size={Icon.sizes.massive}  glyph={Icon.glyphs.font['pi-question-circle']}/>
                        </div>
                        <div className={classes.containerblurb}>
                            Well this is embarrasing. We couldn't find the page you're looking for. Please verify the URL is correct and try again. Or click below to return to the Home Page.
                        </div>
                    </div>
                    <div className={classes.containerfooter}>
                        <Button onClick={handleOnClick} variant="secondary">
                            Return to Home
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                <FooterCommon />
            </div>
        </div>
    )
}